@switch (iconType$$()) {
  @case ('frequency') {
    <i
      class="g-filter-green-600 block h-4 w-4 min-w-4 bg-contain bg-no-repeat"
      [style.background-image]="'url(' + iconPath + '/frequency-icon.svg)'"
      data-testid="row-icon-frequency"
    ></i>
  }

  @case ('trash') {
    <i
      class="g-filter-green-600 block h-4 w-4 min-w-4 bg-contain bg-no-repeat"
      [style.background-image]="'url(' + iconPath + '/trash-container.svg)'"
      data-testid="row-icon-trash"
    ></i>
  }

  @case ('container') {
    <i
      class="g-filter-green-600 block h-4 w-4 min-w-4 bg-contain bg-no-repeat"
      [style.background-image]="'url(' + iconPath + '/container-icon.svg)'"
      data-testid="row-icon-container"
    ></i>
  }

  @case ('bag') {
    <i
      class="g-filter-green-600 block h-4 w-4 min-w-4 bg-contain bg-no-repeat"
      [style.background-image]="'url(' + iconPath + '/bag.svg)'"
      data-testid="row-icon-bag"
    >
    </i>
  }
  @default {
    ! Icon type not found !
  }
}

<span class="text-sm text-blue-900">
  <ng-content></ng-content>
</span>
